import axios from 'axios';
import { strict } from 'assert';

export default {
    name: 'SelectTemplate',
    props: {
        value: [Number, String],
        inputclass: {
            type: String,
            default: ''
        },
        emptyname: {
            type: String,
            default: null
        },
        includeInactive: {
            type: Boolean,
            default: false
        },
        enumtype: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            list: []
        };
    },
    computed: {
        options() {
            return this.list.map(x => {
                return { id: x.id, text: x.title };
            });
        },
    },
    created() {
        this.fetch();
    },
    methods: {
        fetch() {            
            axios.get(APIURL + '/activitytemplate/list/?pageSize=500')
                .then(resp => this.list = resp.data.list);
        },
    }
};